import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

import { ACTION_BUTTON_TYPES, DATE_CONSIDERATIONS, isTrue, WAITLIST_STATUS_TYPES } from "@dp/common";
import { action, computed, makeObservable, observable, runInAction } from "mobx";
import i18next from "i18next";
import moment from "moment-timezone";
import BrandRules from "../../utils/BrandRules";
export var RestaurantDetailModel = (_class = /*#__PURE__*/function () {
  function RestaurantDetailModel() {
    _classCallCheck(this, RestaurantDetailModel);

    _initializerDefineProperty(this, "_selectedRestaurantInLocation", _descriptor, this);

    _initializerDefineProperty(this, "_recentRestaurants", _descriptor2, this);

    _initializerDefineProperty(this, "_favoriteRestaurants", _descriptor3, this);

    _initializerDefineProperty(this, "_userProfile", _descriptor4, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor5, this);

    _initializerDefineProperty(this, "_targeters", _descriptor6, this);

    _initializerDefineProperty(this, "_makeReservationButtonSticky", _descriptor7, this);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor8, this);

    _defineProperty(this, "isRestaurantClosed", function (restaurantTimeZone, closedDays, addDays) {
      var isRestaurantHoliday = false,
          userCurrentDayInTZ;
      var closedDaysLength = closedDays === null || closedDays === void 0 ? void 0 : closedDays.length;
      var formattedClosedDays = closedDays === null || closedDays === void 0 ? void 0 : closedDays.map(function (day) {
        return moment(day, "MM/DD/YYYY").format(DATE_CONSIDERATIONS.DATE_FORMAT);
      });

      if (restaurantTimeZone) {
        var _moment, _moment$tz;

        userCurrentDayInTZ = moment((_moment = moment()) === null || _moment === void 0 ? void 0 : (_moment$tz = _moment.tz(restaurantTimeZone)) === null || _moment$tz === void 0 ? void 0 : _moment$tz.format(DATE_CONSIDERATIONS.DATE_FORMAT)).add(addDays, "days");
      }

      for (var index = 0; index < closedDaysLength; index++) {
        var _userCurrentDayInTZ;

        var closedDay = moment(formattedClosedDays[index]);

        if (closedDay.valueOf() === ((_userCurrentDayInTZ = userCurrentDayInTZ) === null || _userCurrentDayInTZ === void 0 ? void 0 : _userCurrentDayInTZ.valueOf())) {
          isRestaurantHoliday = true;
          break;
        }
      }

      return isRestaurantHoliday;
    });

    makeObservable(this);
  }

  _createClass(RestaurantDetailModel, [{
    key: "setSessionDetails",
    value: function setSessionDetails(_sessionDetails) {
      this._sessionDetails = _sessionDetails;
    }
  }, {
    key: "setUserProfile",
    value: function setUserProfile(data) {
      this._userProfile = data;
    }
  }, {
    key: "setAppAttributes",
    value: function setAppAttributes(data) {
      var _data$configs;

      this._appAttributes = data;
      this._makeReservationButtonSticky = (data === null || data === void 0 ? void 0 : (_data$configs = data.configs) === null || _data$configs === void 0 ? void 0 : _data$configs.makeReservationButtonSticky) === "true" ? true : false;
    }
  }, {
    key: "waitlistAndReservationAvailabilityDescription",
    value: function waitlistAndReservationAvailabilityDescription() {
      var _this$_selectedRestau, _this$_selectedRestau2, _this$_selectedRestau3, _this$_selectedRestau4, _i18next$t;

      switch (this.waitlistAvailabilityStatus) {
        case WAITLIST_STATUS_TYPES.AVAILABLE:
          return i18next.t("text.restdetails.waitlist.available", {
            defaultValue: "We’ll save your place in line to shorten the wait at the following location."
          });

        case WAITLIST_STATUS_TYPES.UNAVAILABLE:
          return "".concat(i18next.t("text.restdetails.waitlist.unavailable.prefix", {
            defaultValue: "Waitlist is only available only between"
          }), " ").concat((_this$_selectedRestau = this._selectedRestaurantInLocation) === null || _this$_selectedRestau === void 0 ? void 0 : (_this$_selectedRestau2 = _this$_selectedRestau.waitlistHours) === null || _this$_selectedRestau2 === void 0 ? void 0 : _this$_selectedRestau2.startTime, " ").concat(i18next.t("text.restdetails.waitlist.unavailable.seperator", {
            defaultValue: "to"
          }), " ").concat((_this$_selectedRestau3 = this._selectedRestaurantInLocation) === null || _this$_selectedRestau3 === void 0 ? void 0 : (_this$_selectedRestau4 = _this$_selectedRestau3.waitlistHours) === null || _this$_selectedRestau4 === void 0 ? void 0 : _this$_selectedRestau4.endTime);

        case WAITLIST_STATUS_TYPES.NOT_AVAILABLE_FOR_THIS_LOCATION:
          return "";

        case WAITLIST_STATUS_TYPES.RESERVATION_ENABLED:
          return isTrue(!!i18next.exists("text.restdetails.waitlist.reservation") && !!((_i18next$t = i18next.t("text.restdetails.waitlist.reservation")) !== null && _i18next$t !== void 0 && _i18next$t.length), i18next.t("text.restdetails.waitlist.reservation"), "");

        default:
          return "";
      }
    }
  }, {
    key: "externalReservationTempLink",
    value: function externalReservationTempLink() {
      var _this$selectedRestaur, _this$selectedRestaur2, _this$selectedRestaur3, _this$selectedRestaur4, _this$selectedRestaur5, _this$selectedRestaur6, _this$selectedRestaur7, _this$selectedRestaur8, _this$selectedRestaur9, _this$selectedRestaur10;

      return isTrue(!!((_this$selectedRestaur = this.selectedRestaurantInLocation) !== null && _this$selectedRestaur !== void 0 && (_this$selectedRestaur2 = _this$selectedRestaur.actionButtonLinks) !== null && _this$selectedRestaur2 !== void 0 && _this$selectedRestaur2.tmpReservationsLnkTxt) && !!((_this$selectedRestaur3 = this.selectedRestaurantInLocation) !== null && _this$selectedRestaur3 !== void 0 && (_this$selectedRestaur4 = _this$selectedRestaur3.actionButtonLinks) !== null && _this$selectedRestaur4 !== void 0 && _this$selectedRestaur4.tmpReservationsLnkURL) && ((_this$selectedRestaur5 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur5 === void 0 ? void 0 : (_this$selectedRestaur6 = _this$selectedRestaur5.actionButtonLinks) === null || _this$selectedRestaur6 === void 0 ? void 0 : (_this$selectedRestaur7 = _this$selectedRestaur6.tmpReservationsLnkTxt) === null || _this$selectedRestaur7 === void 0 ? void 0 : _this$selectedRestaur7.length) > 0 && ((_this$selectedRestaur8 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur8 === void 0 ? void 0 : (_this$selectedRestaur9 = _this$selectedRestaur8.actionButtonLinks) === null || _this$selectedRestaur9 === void 0 ? void 0 : (_this$selectedRestaur10 = _this$selectedRestaur9.tmpReservationsLnkURL) === null || _this$selectedRestaur10 === void 0 ? void 0 : _this$selectedRestaur10.length) > 0, true, false);
    }
  }, {
    key: "siteReservationEnabled",
    value: function siteReservationEnabled() {
      var _this$appAttributes, _this$appAttributes$c, _this$appAttributes2, _this$appAttributes2$;

      return isTrue(!!((_this$appAttributes = this.appAttributes) !== null && _this$appAttributes !== void 0 && (_this$appAttributes$c = _this$appAttributes.configs) !== null && _this$appAttributes$c !== void 0 && _this$appAttributes$c.reservationEnabled) && ((_this$appAttributes2 = this.appAttributes) === null || _this$appAttributes2 === void 0 ? void 0 : (_this$appAttributes2$ = _this$appAttributes2.configs) === null || _this$appAttributes2$ === void 0 ? void 0 : _this$appAttributes2$.reservationEnabled) === "true", true, false);
    }
  }, {
    key: "setTargeters",
    value: function setTargeters(data) {
      this._targeters = data === null || data === void 0 ? void 0 : data.targeter;
    }
  }, {
    key: "setMakeReservationButtonSticky",
    value: function setMakeReservationButtonSticky(data) {
      this._makeReservationButtonSticky = data;
    }
  }, {
    key: "userProfile",
    get: function get() {
      return this._userProfile;
    }
  }, {
    key: "productionURL",
    get: function get() {
      var _this$appAttributes3;

      return (_this$appAttributes3 = this.appAttributes) === null || _this$appAttributes3 === void 0 ? void 0 : _this$appAttributes3.productionURL;
    }
  }, {
    key: "appAttributes",
    get: function get() {
      return this._appAttributes;
    }
  }, {
    key: "selectedRestaurantInLocation",
    get: function get() {
      return this._selectedRestaurantInLocation;
    },
    set: function set(restaurant) {
      var _this = this;

      runInAction(function () {
        _this._selectedRestaurantInLocation = restaurant;
      });
    }
  }, {
    key: "recentRestaurants",
    set: function set(data) {
      var _this2 = this;

      runInAction(function () {
        _this2._recentRestaurants = data;
      });
    },
    get: function get() {
      return this._recentRestaurants;
    }
  }, {
    key: "restaurantAmenities",
    get: function get() {
      var _restaurantInfo$featu, _i18next$t2, _restaurantInfo$featu2, _i18next$t3, _restaurantInfo$featu3;

      var restaurantInfo = this._selectedRestaurantInLocation;
      var amenities = (restaurantInfo === null || restaurantInfo === void 0 ? void 0 : restaurantInfo.amenities) || [];

      if (restaurantInfo !== null && restaurantInfo !== void 0 && (_restaurantInfo$featu = restaurantInfo.features) !== null && _restaurantInfo$featu !== void 0 && _restaurantInfo$featu.curbSideTogoEnabled && !!i18next.exists("text.carsideamenity.title") && !!((_i18next$t2 = i18next.t("text.carsideamenity.title")) !== null && _i18next$t2 !== void 0 && _i18next$t2.length)) {
        amenities === null || amenities === void 0 ? void 0 : amenities.unshift({
          imgURL: i18next.t("link.carsideamenity.img", {
            defaultValue: ""
          }),
          title: i18next.t("text.carsideamenity.title"),
          description: isTrue(i18next.exists("text.carsideamenity.desc"), i18next.t("text.carsideamenity.desc"), "")
        });
      }

      if (restaurantInfo !== null && restaurantInfo !== void 0 && (_restaurantInfo$featu2 = restaurantInfo.features) !== null && _restaurantInfo$featu2 !== void 0 && _restaurantInfo$featu2.onlineTogoEnabled && !!i18next.exists("text.onlineamenity.title") && !!((_i18next$t3 = i18next.t("text.onlineamenity.title")) !== null && _i18next$t3 !== void 0 && _i18next$t3.length)) {
        amenities === null || amenities === void 0 ? void 0 : amenities.unshift({
          imgURL: i18next.t("link.onlineamenity.img", {
            defaultValue: ""
          }),
          title: i18next.t("text.onlineamenity.title"),
          description: isTrue(i18next.exists("text.onlineamenity.desc"), i18next.t("text.onlineamenity.desc"), "")
        });
      }

      if (restaurantInfo !== null && restaurantInfo !== void 0 && (_restaurantInfo$featu3 = restaurantInfo.features) !== null && _restaurantInfo$featu3 !== void 0 && _restaurantInfo$featu3.externalDeliveryEnabled) {
        amenities === null || amenities === void 0 ? void 0 : amenities.push({
          title: "Delivery",
          description: "This location offers food delivery option",
          newAmenity: true
        });
      }

      return amenities;
    }
  }, {
    key: "favoriteRestaurants",
    set: function set(data) {
      var _this3 = this;

      runInAction(function () {
        _this3._favoriteRestaurants = data;
      });
    },
    get: function get() {
      return this._favoriteRestaurants;
    }
  }, {
    key: "waitlistAvailabilityStatus",
    get: function get() {
      var _this$_selectedRestau5, _this$_selectedRestau6, _this$_selectedRestau7, _this$_selectedRestau8;

      if ((_this$_selectedRestau5 = this._selectedRestaurantInLocation) !== null && _this$_selectedRestau5 !== void 0 && (_this$_selectedRestau6 = _this$_selectedRestau5.features) !== null && _this$_selectedRestau6 !== void 0 && _this$_selectedRestau6.reservationEnabled) {
        return WAITLIST_STATUS_TYPES.RESERVATION_ENABLED;
      }

      if (!!((_this$_selectedRestau7 = this._selectedRestaurantInLocation) !== null && _this$_selectedRestau7 !== void 0 && (_this$_selectedRestau8 = _this$_selectedRestau7.features) !== null && _this$_selectedRestau8 !== void 0 && _this$_selectedRestau8.waitListEnabled)) {
        var _this$_selectedRestau9, _this$_selectedRestau10;

        if (!!((_this$_selectedRestau9 = this._selectedRestaurantInLocation) !== null && _this$_selectedRestau9 !== void 0 && (_this$_selectedRestau10 = _this$_selectedRestau9.features) !== null && _this$_selectedRestau10 !== void 0 && _this$_selectedRestau10.waitListOn)) {
          return WAITLIST_STATUS_TYPES.AVAILABLE;
        } else return WAITLIST_STATUS_TYPES.UNAVAILABLE;
      }

      return WAITLIST_STATUS_TYPES.NOT_AVAILABLE_FOR_THIS_LOCATION;
    }
  }, {
    key: "holidayMessage",
    get: function get() {
      var _this$_selectedRestau11, _this$_selectedRestau12, _this$_selectedRestau13, _this$_selectedRestau14, _this$_selectedRestau15;

      return ((_this$_selectedRestau11 = this._selectedRestaurantInLocation) === null || _this$_selectedRestau11 === void 0 ? void 0 : (_this$_selectedRestau12 = _this$_selectedRestau11.restaurantHours) === null || _this$_selectedRestau12 === void 0 ? void 0 : (_this$_selectedRestau13 = _this$_selectedRestau12[0]) === null || _this$_selectedRestau13 === void 0 ? void 0 : (_this$_selectedRestau14 = _this$_selectedRestau13.hoursInfo) === null || _this$_selectedRestau14 === void 0 ? void 0 : (_this$_selectedRestau15 = _this$_selectedRestau14.find(function (hourObj) {
        return hourObj.hourCode === "HOM_REST";
      })) === null || _this$_selectedRestau15 === void 0 ? void 0 : _this$_selectedRestau15.overrideMessage) || "";
    }
  }, {
    key: "restaurantStatusMessage",
    get: function get() {
      var _this$_selectedRestau16;

      var currentDayOPHours = (_this$_selectedRestau16 = this._selectedRestaurantInLocation) === null || _this$_selectedRestau16 === void 0 ? void 0 : _this$_selectedRestau16.operationalHours;
      return i18next.t("text.locationsearch.status.opentill", {
        interpolation: {
          prefix: "${",
          suffix: "}"
        },
        starttime: currentDayOPHours === null || currentDayOPHours === void 0 ? void 0 : currentDayOPHours.startTime,
        endtime: currentDayOPHours === null || currentDayOPHours === void 0 ? void 0 : currentDayOPHours.endTime,
        defaultValue: "Open today ".concat(currentDayOPHours === null || currentDayOPHours === void 0 ? void 0 : currentDayOPHours.startTime, " to ").concat(currentDayOPHours === null || currentDayOPHours === void 0 ? void 0 : currentDayOPHours.endTime)
      });
    }
  }, {
    key: "isWaitlistSectionButtonDisabled",
    get: function get() {
      var _this$selectedRestaur11, _this$selectedRestaur12;

      return !!!((_this$selectedRestaur11 = this.selectedRestaurantInLocation) !== null && _this$selectedRestaur11 !== void 0 && (_this$selectedRestaur12 = _this$selectedRestaur11.features) !== null && _this$selectedRestaur12 !== void 0 && _this$selectedRestaur12.waitListOn);
    }
  }, {
    key: "restOpensinFuture",
    get: function get() {
      var _this$selectedRestaur13, _this$selectedRestaur14;

      return !!((_this$selectedRestaur13 = this.selectedRestaurantInLocation) !== null && _this$selectedRestaur13 !== void 0 && (_this$selectedRestaur14 = _this$selectedRestaur13.features) !== null && _this$selectedRestaur14 !== void 0 && _this$selectedRestaur14.isComingSoon);
    }
  }, {
    key: "isReservationEnabled",
    get: function get() {
      var _this$selectedRestaur15, _this$selectedRestaur16;

      return !!((_this$selectedRestaur15 = this.selectedRestaurantInLocation) !== null && _this$selectedRestaur15 !== void 0 && (_this$selectedRestaur16 = _this$selectedRestaur15.features) !== null && _this$selectedRestaur16 !== void 0 && _this$selectedRestaur16.reservationEnabled);
    }
  }, {
    key: "hideWaitlistSection",
    get: function get() {
      var _this$selectedRestaur17, _this$selectedRestaur18;

      return !!!((_this$selectedRestaur17 = this.selectedRestaurantInLocation) !== null && _this$selectedRestaur17 !== void 0 && (_this$selectedRestaur18 = _this$selectedRestaur17.features) !== null && _this$selectedRestaur18 !== void 0 && _this$selectedRestaur18.waitListEnabled) && !!!this.isReservationEnabled;
    }
  }, {
    key: "hideAmenitiesList",
    get: function get() {
      var _this$appAttributes4, _this$appAttributes4$, _this$appAttributes4$2;

      return ((_this$appAttributes4 = this.appAttributes) === null || _this$appAttributes4 === void 0 ? void 0 : (_this$appAttributes4$ = _this$appAttributes4.configs) === null || _this$appAttributes4$ === void 0 ? void 0 : (_this$appAttributes4$2 = _this$appAttributes4$.hideAmenitiesList) === null || _this$appAttributes4$2 === void 0 ? void 0 : _this$appAttributes4$2.split(",")) || [];
    }
  }, {
    key: "hideDisabledOrderOnlineCTA",
    get: function get() {
      var _this$appAttributes5, _this$appAttributes5$;

      return ((_this$appAttributes5 = this.appAttributes) === null || _this$appAttributes5 === void 0 ? void 0 : (_this$appAttributes5$ = _this$appAttributes5.configs) === null || _this$appAttributes5$ === void 0 ? void 0 : _this$appAttributes5$.hideDisabledOrderOnlineCTA) === "true";
    }
  }, {
    key: "targeters",
    get: function get() {
      return this._targeters;
    }
  }, {
    key: "isHappyHourEnabled",
    get: function get() {
      var _this$appAttributes6, _this$appAttributes6$;

      return ((_this$appAttributes6 = this.appAttributes) === null || _this$appAttributes6 === void 0 ? void 0 : (_this$appAttributes6$ = _this$appAttributes6.configs) === null || _this$appAttributes6$ === void 0 ? void 0 : _this$appAttributes6$.isHappyHourEnabled) === "true";
    }
  }, {
    key: "showHappyHour",
    get: function get() {
      var _this$selectedRestaur19, _this$selectedRestaur20;

      return (_this$selectedRestaur19 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur19 === void 0 ? void 0 : (_this$selectedRestaur20 = _this$selectedRestaur19.features) === null || _this$selectedRestaur20 === void 0 ? void 0 : _this$selectedRestaur20.showHappyHour;
    }
  }, {
    key: "hideAmenityDescription",
    get: function get() {
      var _this$appAttributes7, _this$appAttributes7$;

      return ((_this$appAttributes7 = this.appAttributes) === null || _this$appAttributes7 === void 0 ? void 0 : (_this$appAttributes7$ = _this$appAttributes7.configs) === null || _this$appAttributes7$ === void 0 ? void 0 : _this$appAttributes7$.hideDescriptionForAmenities) === "true";
    }
  }, {
    key: "isLiveMusicEnabled",
    get: function get() {
      var _this$appAttributes8, _this$appAttributes8$;

      return ((_this$appAttributes8 = this.appAttributes) === null || _this$appAttributes8 === void 0 ? void 0 : (_this$appAttributes8$ = _this$appAttributes8.configs) === null || _this$appAttributes8$ === void 0 ? void 0 : _this$appAttributes8$.isLiveMusicEnabled) === "true";
    }
  }, {
    key: "showEventCalendar",
    get: function get() {
      var _this$selectedRestaur21, _this$selectedRestaur22;

      return (_this$selectedRestaur21 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur21 === void 0 ? void 0 : (_this$selectedRestaur22 = _this$selectedRestaur21.features) === null || _this$selectedRestaur22 === void 0 ? void 0 : _this$selectedRestaur22.showEventCalendar;
    }
  }, {
    key: "displayBrandImageInRestDetails",
    get: function get() {
      var _this$appAttributes9, _this$appAttributes9$;

      return ((_this$appAttributes9 = this.appAttributes) === null || _this$appAttributes9 === void 0 ? void 0 : (_this$appAttributes9$ = _this$appAttributes9.configs) === null || _this$appAttributes9$ === void 0 ? void 0 : _this$appAttributes9$.displayBrandImageInRestDetails) === "true";
    }
  }, {
    key: "showPrivateDining",
    get: function get() {
      var _this$appAttributes10, _this$appAttributes11;

      return ((_this$appAttributes10 = this.appAttributes) === null || _this$appAttributes10 === void 0 ? void 0 : (_this$appAttributes11 = _this$appAttributes10.configs) === null || _this$appAttributes11 === void 0 ? void 0 : _this$appAttributes11.showPrivateDining) === "true";
    }
  }, {
    key: "privateDiningHome",
    get: function get() {
      var _this$appAttributes12, _this$appAttributes13;

      return (_this$appAttributes12 = this.appAttributes) === null || _this$appAttributes12 === void 0 ? void 0 : (_this$appAttributes13 = _this$appAttributes12.configs) === null || _this$appAttributes13 === void 0 ? void 0 : _this$appAttributes13.privateDiningHome;
    }
  }, {
    key: "happyHourLinkForRD",
    get: function get() {
      var _this$selectedRestaur23, _this$selectedRestaur24, _this$selectedRestaur25, _this$selectedRestaur26, _this$selectedRestaur27, _this$selectedRestaur28, _this$selectedRestaur29, _this$selectedRestaur30, _city$toLowerCase, _city$toLowerCase$spl, _city$toLowerCase$spl2;

      var state = (_this$selectedRestaur23 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur23 === void 0 ? void 0 : (_this$selectedRestaur24 = _this$selectedRestaur23.contactDetail) === null || _this$selectedRestaur24 === void 0 ? void 0 : (_this$selectedRestaur25 = _this$selectedRestaur24.address) === null || _this$selectedRestaur25 === void 0 ? void 0 : (_this$selectedRestaur26 = _this$selectedRestaur25.stateCode) === null || _this$selectedRestaur26 === void 0 ? void 0 : _this$selectedRestaur26.toLowerCase();
      var city = (_this$selectedRestaur27 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur27 === void 0 ? void 0 : (_this$selectedRestaur28 = _this$selectedRestaur27.contactDetail) === null || _this$selectedRestaur28 === void 0 ? void 0 : (_this$selectedRestaur29 = _this$selectedRestaur28.address) === null || _this$selectedRestaur29 === void 0 ? void 0 : _this$selectedRestaur29.city;
      var restNum = (_this$selectedRestaur30 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur30 === void 0 ? void 0 : _this$selectedRestaur30.restaurantNumber;
      var modifiedCity = city === null || city === void 0 ? void 0 : (_city$toLowerCase = city.toLowerCase()) === null || _city$toLowerCase === void 0 ? void 0 : (_city$toLowerCase$spl = _city$toLowerCase.split(" ")) === null || _city$toLowerCase$spl === void 0 ? void 0 : (_city$toLowerCase$spl2 = _city$toLowerCase$spl.join("-")) === null || _city$toLowerCase$spl2 === void 0 ? void 0 : _city$toLowerCase$spl2.concat("-restaurant");
      var defaultValue = "/happy-hour/".concat(state === null || state === void 0 ? void 0 : state.toLowerCase(), "/").concat(modifiedCity, "/").concat(restNum);

      if (state && city && restNum) {
        return i18next.t("label.restdetails.actionbuttons.happyhoururl", {
          defaultValue: defaultValue,
          interpolation: {
            prefix: "${",
            suffix: "}"
          },
          0: state,
          1: modifiedCity,
          2: restNum
        });
      } else {
        return "/happy-hour";
      }
    }
  }, {
    key: "liveMusicLink",
    get: function get() {
      var _this$selectedRestaur31, _this$selectedRestaur32, _this$selectedRestaur33, _this$selectedRestaur34, _this$selectedRestaur35, _this$selectedRestaur36, _this$selectedRestaur37, _this$selectedRestaur38, _city$toLowerCase2, _city$toLowerCase2$sp, _city$toLowerCase2$sp2;

      var _state = (_this$selectedRestaur31 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur31 === void 0 ? void 0 : (_this$selectedRestaur32 = _this$selectedRestaur31.contactDetail) === null || _this$selectedRestaur32 === void 0 ? void 0 : (_this$selectedRestaur33 = _this$selectedRestaur32.address) === null || _this$selectedRestaur33 === void 0 ? void 0 : (_this$selectedRestaur34 = _this$selectedRestaur33.stateCode) === null || _this$selectedRestaur34 === void 0 ? void 0 : _this$selectedRestaur34.toLowerCase();

      var _city = (_this$selectedRestaur35 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur35 === void 0 ? void 0 : (_this$selectedRestaur36 = _this$selectedRestaur35.contactDetail) === null || _this$selectedRestaur36 === void 0 ? void 0 : (_this$selectedRestaur37 = _this$selectedRestaur36.address) === null || _this$selectedRestaur37 === void 0 ? void 0 : _this$selectedRestaur37.city;

      var _restNum = (_this$selectedRestaur38 = this.selectedRestaurantInLocation) === null || _this$selectedRestaur38 === void 0 ? void 0 : _this$selectedRestaur38.restaurantNumber;

      var _modifiedCity = _city === null || _city === void 0 ? void 0 : (_city$toLowerCase2 = _city.toLowerCase()) === null || _city$toLowerCase2 === void 0 ? void 0 : (_city$toLowerCase2$sp = _city$toLowerCase2.split(" ")) === null || _city$toLowerCase2$sp === void 0 ? void 0 : (_city$toLowerCase2$sp2 = _city$toLowerCase2$sp.join("-")) === null || _city$toLowerCase2$sp2 === void 0 ? void 0 : _city$toLowerCase2$sp2.concat("-restaurant");

      var _defaultValue = "/live-music/".concat(_state === null || _state === void 0 ? void 0 : _state.toLowerCase(), "/").concat(_modifiedCity, "/").concat(_restNum);

      if (_state && _city && _restNum) {
        return i18next.t("label.restdetails.actionbuttons.livemusicurl", {
          defaultValue: _defaultValue,
          interpolation: {
            prefix: "${",
            suffix: "}"
          },
          0: _state,
          1: _modifiedCity,
          2: _restNum
        });
      } else {
        return "/live-music";
      }
    }
  }, {
    key: "actionButtonsOrder",
    get: function get() {
      var _this$_appAttributes, _this$_appAttributes$, _this$_appAttributes$2;

      return ((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : (_this$_appAttributes$2 = _this$_appAttributes$.actionButtonsOrder) === null || _this$_appAttributes$2 === void 0 ? void 0 : _this$_appAttributes$2.split(",").map(function (str) {
        return str === null || str === void 0 ? void 0 : str.trim();
      })) || [ACTION_BUTTON_TYPES.VIEW_MENU_BTN, ACTION_BUTTON_TYPES.ORDER_AHEAD_BTN, ACTION_BUTTON_TYPES.APPLY_NOW_BTN, ACTION_BUTTON_TYPES.HAPPY_HOUR_BTN, ACTION_BUTTON_TYPES.PRIVATE_DINING_BTN, ACTION_BUTTON_TYPES.LIVE_MUSIC_BTN];
    }
  }, {
    key: "isReservationButtonSticky",
    get: function get() {
      var _this$_selectedRestau17, _this$_selectedRestau18, _this$_selectedRestau19, _this$_selectedRestau20, _this$_selectedRestau21, _this$_selectedRestau22, _this$_selectedRestau23, _this$_selectedRestau24;

      if (!!((_this$_selectedRestau17 = this._selectedRestaurantInLocation) !== null && _this$_selectedRestau17 !== void 0 && (_this$_selectedRestau18 = _this$_selectedRestau17.features) !== null && _this$_selectedRestau18 !== void 0 && _this$_selectedRestau18.isReservationButtonSticky) && !!((_this$_selectedRestau19 = this._selectedRestaurantInLocation) !== null && _this$_selectedRestau19 !== void 0 && (_this$_selectedRestau20 = _this$_selectedRestau19.features) !== null && _this$_selectedRestau20 !== void 0 && _this$_selectedRestau20.isOrderOnlineButtonSticky)) return !!((_this$_selectedRestau21 = this._selectedRestaurantInLocation) !== null && _this$_selectedRestau21 !== void 0 && (_this$_selectedRestau22 = _this$_selectedRestau21.features) !== null && _this$_selectedRestau22 !== void 0 && _this$_selectedRestau22.reservationEnabled);
      return !!((_this$_selectedRestau23 = this._selectedRestaurantInLocation) !== null && _this$_selectedRestau23 !== void 0 && (_this$_selectedRestau24 = _this$_selectedRestau23.features) !== null && _this$_selectedRestau24 !== void 0 && _this$_selectedRestau24.isReservationButtonSticky);
    }
  }, {
    key: "isOrderOnlineButtonSticky",
    get: function get() {
      var _this$_selectedRestau25, _this$_selectedRestau26;

      return !!((_this$_selectedRestau25 = this._selectedRestaurantInLocation) !== null && _this$_selectedRestau25 !== void 0 && (_this$_selectedRestau26 = _this$_selectedRestau25.features) !== null && _this$_selectedRestau26 !== void 0 && _this$_selectedRestau26.isOrderOnlineButtonSticky);
    }
  }, {
    key: "showOrderAhead",
    get: function get() {
      var _this$selectedRestaur39, _this$selectedRestaur40;

      return !!((_this$selectedRestaur39 = this.selectedRestaurantInLocation) !== null && _this$selectedRestaur39 !== void 0 && (_this$selectedRestaur40 = _this$selectedRestaur39.features) !== null && _this$selectedRestaur40 !== void 0 && _this$selectedRestaur40.orderAheadEnabled);
    }
  }, {
    key: "isPermanentlyClosed",
    get: function get() {
      var _this$_selectedRestau27, _this$_selectedRestau28;

      return (_this$_selectedRestau27 = this._selectedRestaurantInLocation) === null || _this$_selectedRestau27 === void 0 ? void 0 : (_this$_selectedRestau28 = _this$_selectedRestau27.features) === null || _this$_selectedRestau28 === void 0 ? void 0 : _this$_selectedRestau28.isPermanentlyClosed;
    }
  }, {
    key: "showExploreRestDetailsCTA",
    get: function get() {
      var _this$_appAttributes2;

      return new BrandRules(this === null || this === void 0 ? void 0 : (_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : _this$_appAttributes2.currentConceptCode).showExploreRestDetailsCTA();
    }
  }]);

  return RestaurantDetailModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_selectedRestaurantInLocation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_recentRestaurants", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_favoriteRestaurants", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_userProfile", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_targeters", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_makeReservationButtonSticky", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setSessionDetails", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSessionDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userProfile", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "userProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUserProfile", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUserProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "productionURL", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "productionURL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "appAttributes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "appAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAppAttributes", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAppAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recentRestaurants", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "recentRestaurants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantAmenities", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantAmenities"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "favoriteRestaurants", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "favoriteRestaurants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "waitlistAvailabilityStatus", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "waitlistAvailabilityStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "holidayMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "holidayMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantStatusMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantStatusMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWaitlistSectionButtonDisabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isWaitlistSectionButtonDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restOpensinFuture", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restOpensinFuture"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isReservationEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isReservationEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideWaitlistSection", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideWaitlistSection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideAmenitiesList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideAmenitiesList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideDisabledOrderOnlineCTA", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideDisabledOrderOnlineCTA"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targeters", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "targeters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTargeters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setTargeters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isHappyHourEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isHappyHourEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showHappyHour", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showHappyHour"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideAmenityDescription", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideAmenityDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLiveMusicEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLiveMusicEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showEventCalendar", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showEventCalendar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayBrandImageInRestDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayBrandImageInRestDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPrivateDining", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPrivateDining"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "privateDiningHome", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "privateDiningHome"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "happyHourLinkForRD", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "happyHourLinkForRD"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "liveMusicLink", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "liveMusicLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "actionButtonsOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "actionButtonsOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isReservationButtonSticky", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isReservationButtonSticky"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderOnlineButtonSticky", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderOnlineButtonSticky"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setMakeReservationButtonSticky", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setMakeReservationButtonSticky"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showOrderAhead", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showOrderAhead"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPermanentlyClosed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPermanentlyClosed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showExploreRestDetailsCTA", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showExploreRestDetailsCTA"), _class.prototype)), _class);